import styled from 'styled-components';

import { CloseIcon } from '@spa/shared/svg/close';

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0 ${props => props.theme.space(4)};
  position: ${props => (props.isSticky ? 'fixed' : 'absolute')};
  top: 0;
  left: 0;
  z-index: 2;
  background: ${props => props.theme.header.mobile.background};
  transform: translateY(0);

  animation: ${props => (props.isSticky ? 'slideDown 0.8s ease-out' : null)};

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-60px);
    }

    to {
      opacity: 1;
    }
  }
`;

export const Close = styled(CloseIcon)`
  width: 20px;

  path {
    fill: ${props => props.theme.header.mobile.closePath};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & svg:first-child {
    width: 140px;
    height: 33px;
  }

  .hamburger {
    g {
      fill: ${props => props.theme.header.mobile.hamburger};
    }
  }
`;

export const Menu = styled.ul`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  transform: translate3d(0, -100%, 0);
  transition: transform 0.25s ease-out;
  background-color: ${props => props.theme.header.background};
  padding: ${props => props.theme.space(15)} ${props => props.theme.space(8)};
  z-index: 11;
  overflow-y: scroll;
  height: 100vh;
`;

export const Welcome = styled.h2`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(32)};
  color: ${props => props.theme.header.mobile.welcome.color};
  margin-top: 14px;
  margin-bottom: 14px;
`;

export const Item = styled.li`
  display: ${props => (props.hide ? 'none' : 'flex')};
  width: 100%;
  padding: ${props => props.theme.space(3)} 0;

  &:focus {
    text-decoration: none;
  }

  a {
    &.back-to-uniplaces,
    &.back-to-residences {
      border: 2px solid ${props => props.theme.header.mobile.svg.gPathFill};
      padding: ${props => props.theme.space(1)} ${props => props.theme.space(3)};
      border-radius: 8px;
    }
  }

  a {
    text-decoration: none;
    font-family: IntervalNextReg, sans-serif;
    font-weight: 100;
    line-height: normal;
    color: ${props => props.theme.header.mobile.svg.gPathFill};
    font-size: ${props => props.theme.rem(16)};
  }
`;

export const Input = styled.input`
  display: none;

  &:checked ~ ${Wrapper} {
    position: fixed;
    display: flex;
    z-index: 12;
    justify-content: space-between;
    background-color: ${props => props.theme.header.background};
    left: 0;
    padding: ${props => props.theme.space(4)};

    & svg:first-child {
      path {
        transition: fill 0.25s ease-out;
        fill: ${props => props.theme.header.mobile.svg.pathFill};
      }

      g {
        path {
          transition: fill 0.25s ease-out;
          fill: ${props => props.theme.header.mobile.svg.gPathFill};
        }
      }
    }

    & ${Close} {
      path {
        transition: fill 0.25s ease-out;
      }
    }
  }

  &:checked ~ ${Menu} {
    transform: translate3d(0, 0, 0);
    padding-bottom: ${props => props.theme.space(35)};
  }
`;

export const Separator = styled.li`
  border-bottom: 1px solid ${props => props.theme.header.mobile.separator.borderColor};
  margin: ${props => props.theme.space(3)} 0;
`;

export const SSOItem = styled.li`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${props => props.theme.header.mobile.separator.borderColor};
  margin-bottom: ${props => props.theme.space(2)};

  a {
    text-decoration: none;
    font-family: IntervalNextReg, sans-serif;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
    font-weight: 400;
    margin: 16px 0;
    height: 44px;
    width: 48%;
    display: flex;
    border: 2px solid transparent;
    font-size: ${props => props.theme.rem(18)};

    &.login {
      color: ${props => props.theme.header.mobile.login.color};
      background-color: ${props => props.theme.header.mobile.login.background};
      border: 1px solid ${props => props.theme.header.mobile.login.color};
      border-radius: 8px;
    }

    &.signup {
      color: ${props => props.theme.header.mobile.signup.color};
      background-color: ${props => props.theme.header.mobile.signup.background};
      border-radius: 8px;
    }
  }
`;

export const UniversityLogo = styled.img`
  max-width: 250px;
  max-height: 60px;
`;

export const PartnerLogo = styled.img`
  height: 40px;
`;
